import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Tooltip,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { PlusIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from '../messages';
import { DISABLE_REASON_MAP } from '../constants';

const AddNewVoucherButton = ({
  organizationId,
  propertyId,
  householdId,
  disabled,
  disableReason,
  intl,
  handleOpenModal,
}) => {
  const button = (
    <Button
      variant={'shout'}
      disabled={disabled}
      intl={intl}
      startIcon={<PlusIcon />}
      onClick={() => {
        handleOpenModal({
          organizationId,
          propertyId,
          householdId,
          modalType: 'createVoucher',
        });
      }}
    >
      <FormattedMessage {...messages.addNewVoucher} />
    </Button>
  );

  // Show tooltip only when disabled due to future voucher
  if (disabled && disableReason) {
    const messageName = DISABLE_REASON_MAP[disableReason];

    return (
      <Tooltip
        title={<FormattedMessage {...messages[messageName]} />}
        placement="top"
      >
        <span style={{ display: 'inline-block' }}>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default AddNewVoucherButton;
